module.exports = __webpack_public_path__ + "static/img/bcg2.21c0aa01.png";